import { createTheme } from "@mui/material/styles";

import colors from "./base/colors";
import typography from "./base/typography";
import borders from "./base/borders";
import boxShadows from "./base/boxShadows";
import breakpoints from "./base/breakpoints";
import functions from "./functions";

const theme = createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  borders: { ...borders },
  boxShadows: { ...boxShadows },
  functions: { ...functions },
});

export default theme;
